import React from "react";
import PayoutCheckerDashboard from "../../components/PayoutCheckerDashBoard/PayoutCheckerDashboard";


const PayoutCheckerDashboardContainers = () => {
  return <PayoutCheckerDashboard />;
};

export default PayoutCheckerDashboardContainers;
